import styled from '@emotion/styled';

export const Page = styled.div`
  padding: 24px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  background: #fff;
  color: rgba(0, 0, 0, 0.87);

  .wrapper-restrict-width {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }

  main {
    margin: auto 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    .logo {
      height: 3rem;
    }
  }

  footer {
    text-align: center;
    font-size: 0.75rem;
    line-height: 16px;
    letter-spacing: 0.4px;

    a {
      color: var(--indigo);
      text-decoration: none;
    }
  }
`;
